/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend({
        defaults: {
            galleryUrlSlug: null,
            productGroupName: null,
            color: null,
            productSlug: null,
            numOfSides: null,
            sideNames: [],
            query: null,
            page: null,
            totalPages: null,
            orientation: null,
            templatesPerPage: null,
            quantity: null,
            categories: []
        },

        /**
         * @param {string|number} page
         * @returns {DesignGalleryModel}
         */
        setPage: function(page) {
            var destinationPage = parseInt(page);
            var totalPages = parseInt(this.get('totalPages'));

            if (destinationPage > totalPages) {
                this.set('page', totalPages);
            } else {
                this.set('page', destinationPage);
            }

            return this;
        },

        /**
         * @param {string} category
         */
        addCategory: function(category) {
            var categories = this.get('categories');
            if (categories.indexOf(category) === -1) {
                categories.push(category);
                this.set('categories', categories);
            }
        },

        /**
         * @param {string} category
         */
        removeCategory: function(category) {
            var categories = this.get('categories');
            var index = categories.indexOf(category);
            if (index > -1) {
                categories.splice(index, 1);
                this.set('categories', categories);
            }
        }
    });
});
